/**
 * Display helpers for portfolio keys on the (scoped) dashboard. The dashboard only receives portfolio
 * *keys* (ids) on its domains — the human-facing names live in the admin portfolios table, which the
 * dashboard doesn't fetch — so the four official full names are mapped here. The acronym is just the
 * id uppercased (cads → CADS); the reserved bucket reads "Unassigned".
 */
export const UNASSIGNED = '_unassigned';

/** id → full portfolio name, for the four official portfolios. */
export const PORTFOLIO_NAMES: Record<string, string> = {
  cads: 'Cox Automotive Data Solutions',
  ete: 'Enterprise Technology & Engineering',
  ers: 'Enterprise Risk & Security',
  et: 'Enterprise Transformation'
};

/** Short label: "Unassigned" for the reserved bucket, otherwise the id uppercased (CADS, ETE…). */
export const portfolioAcronym = (key: string): string =>
  key === UNASSIGNED ? 'Unassigned' : key.toUpperCase();

/** Full name if known (official four), else falls back to the acronym. */
export const portfolioFullName = (key: string): string =>
  key === UNASSIGNED ? 'Unassigned' : PORTFOLIO_NAMES[key] ?? portfolioAcronym(key);
